import { render, staticRenderFns } from "./emergencyuser.vue?vue&type=template&id=10760a60"
import script from "./emergencyuser.vue?vue&type=script&lang=js"
export * from "./emergencyuser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports